export default __webpack_public_path__ + "static/media/Belt of the Sanguine Disciple.00325903.jpg";